import React, { useMemo, useState } from "react";
import classNames from "classnames";
import { Link } from "../link";
import BannerMenu from "./banner-menu";
import { linKFromSlug } from "../../utility/paths";
import AccessoriesAndConsumablesBannerMenu from "./accessories-and-consumables-banner-menu";
import Arrow from "../../icons/chevron-right-light.svg";

const enterMobileProps = (onHover) => {
  let timeout;
  return {
    onMouseEnter: () => {
      timeout = setTimeout(onHover, 200);
    },
    onClick: () => clearTimeout(timeout),
  };
};

const NavigationSubItem = ({
  item,
  link,
  externalLink,
  title,
  target,
  navigationMenuItems,
  origin,
  onHover,
}) => {
  return (
    <div className="new-navigation__subitem">
      <div
        className={classNames(
          "new-navigation__link d-flex align-items-start",
          origin === "support" && "new-navigation__link--support",
          origin !== "support" && (link || externalLink) && "new-navigation__link-svg",
          origin !== "support" && !(link || externalLink) && "new-navigation__link--no-click"
        )}
      >
        <div
          className="d-flex flex-lg-column align-items-center align-items-lg-start"
          {...enterMobileProps(onHover)}
        >
          <div className="mb-lg-0">
            {link && origin !== "support" ? (
              <>
                <Link className="d-block" to={linKFromSlug(link)}>
                  {title}
                  <Arrow />
                </Link>
              </>
            ) : externalLink && origin !== "support" ? (
              <a
                className="d-block"
                href={externalLink}
                target={target ? target[0] : ""}
                rel={target[0] === "_blank" ? "noopener noreferrer" : ""}
              >
                {title}
                <Arrow />
              </a>
            ) : (
              <>
                <span
                  className={classNames(
                    "d-block",
                    origin === "language" && "new-navigation__page-link pl-1 pt-0"
                  )}
                >
                  {title}
                </span>
                {origin !== "support" && origin !== "language" && (
                  <div className="new-navigation__accessory-bar new-navigation__accessory-bar--no-click"></div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {origin === "support" && navigationMenuItems?.length ? (
        <div className="new-navigation__mobile-bar"></div>
      ) : null}
      {navigationMenuItems?.length &&
      navigationMenuItems.filter(
        (item) =>
          item.content.__typename !== "LiferayBannerMenu" &&
          item.content.__typename !== "LiferayAcBannerMenu"
      )?.length ? (
        <div
          className={classNames(
            "new-navigation__sub-category-wrapper mt-lg-3",
            origin === "support" && "new-navigation__sub-category-wrapper--support"
          )}
        >
          {navigationMenuItems
            .filter(
              (item) =>
                item.content.__typename !== "LiferayBannerMenu" &&
                item.content.__typename !== "LiferayAcBannerMenu"
            )
            ?.map((subItem, i) => (
              <div
                key={i}
                className={classNames(
                  "new-navigation__sub-category-link-wrapper",
                  origin === "support" && "new-navigation__sub-category-link-wrapper--support"
                )}
                {...enterMobileProps(onHover)}
              >
                {subItem?.content?.slug ? (
                  <>
                    <Link
                      className={classNames(
                        "new-navigation__sub-category",
                        origin === "support" && "new-navigation__sub-category--support"
                      )}
                      to={linKFromSlug(subItem?.content?.slug)}
                    >
                      {subItem.useCustomName && subItem.name
                        ? subItem.name
                        : subItem?.content?.pageNameMenu || subItem?.content?.liferayFields?.title}
                    </Link>{" "}
                  </>
                ) : subItem?.content?.externalLink ? (
                  <a
                    className={classNames(
                      "new-navigation__sub-category",
                      origin === "support" && "new-navigation__sub-category--support"
                    )}
                    href={subItem?.content?.externalLink}
                    target={item.content.target ? item.content.target[0] : ""}
                    rel={
                      item.content.target && item.content.target[0] === "_blank"
                        ? "noopener noreferrer"
                        : ""
                    }
                  >
                    {subItem.useCustomName && subItem.name
                      ? subItem.name
                      : subItem?.content?.pageNameMenu || subItem?.content?.liferayFields?.title}
                  </a>
                ) : (
                  <span
                    className={classNames(
                      "new-navigation__sub-category",
                      origin === "support" && "new-navigation__sub-category--support"
                    )}
                  >
                    {subItem.useCustomName && subItem.name
                      ? subItem.name
                      : subItem?.content?.pageNameMenu || subItem?.content?.liferayFields?.title}
                  </span>
                )}
              </div>
            ))}
        </div>
      ) : null}
    </div>
  );
};

const NewNavigationMegamenu = ({ item, bannerMenu, origin, defaultBanner, navigationRef }) => {
  const [hoverId, setHoverId] = useState(-1);
  const categoryBanner =
    item?.navigationMenuItems?.length > 0
      ? item.navigationMenuItems.find(
          (item) =>
            item.content.__typename === "LiferayBannerMenu" &&
            item.navigationMenuItems?.length === 0
        )
      : null;
  const acBanner =
    item?.navigationMenuItems?.length > 0
      ? item.navigationMenuItems.find((item) => item.content.__typename === "LiferayAcBannerMenu")
      : null;
  const menuItems = useMemo(() => {
    return item?.navigationMenuItems?.length > 0
      ? item.navigationMenuItems.filter(
          (item) =>
            item.content.__typename !== "LiferayBannerMenu" &&
            item.content.__typename !== "LiferayAcBannerMenu"
        )
      : [];
  }, [item?.navigationMenuItems]);

  const showVerticalBanner =
    (menuItems?.length > 6 && (!acBanner || !acBanner?.navigationMenuItems?.length)) ||
    (menuItems?.length > 5 &&
      menuItems?.find((item) => item?.navigationMenuItems?.length) &&
      (!acBanner || !acBanner?.navigationMenuItems?.length));

  const changeOrder = useMemo(() => {
    const acIndex = item.navigationMenuItems.findIndex(
      (item) => item.content.__typename === "LiferayAcBannerMenu"
    );
    const bmIndex = item.navigationMenuItems.findIndex(
      (item) => item.content.__typename === "LiferayBannerMenu"
    );
    if (acIndex >= 0 && bmIndex >= 0 && hoverId === -1) {
      return bmIndex < acIndex;
    }

    if (acIndex >= 0 && hoverId !== -1) {
      const acInnerIndex = menuItems[hoverId]?.navigationMenuItems?.findIndex(
        (subItem) =>
          subItem.content.__typename === "LiferayAcBannerMenu" &&
          subItem.navigationMenuItems?.length === 0
      );
      const bmInnerIndex = menuItems[hoverId]?.navigationMenuItems?.findIndex(
        (subItem) =>
          subItem.content.__typename === "LiferayBannerMenu" &&
          subItem.navigationMenuItems?.length === 0
      );

      return (
        (acInnerIndex >= 0 && bmInnerIndex >= 0 && bmInnerIndex < acInnerIndex) ||
        ((acInnerIndex === -1 || bmInnerIndex === -1) &&
          acIndex >= 0 &&
          bmIndex >= 0 &&
          bmIndex < acIndex)
      );
    }
  }, [item, hoverId, menuItems]);

  return (
    <div
      ref={navigationRef}
      className={classNames(
        "new-navigation__wrapper",
        origin === "support" && "new-navigation__wrapper--support"
      )}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex flex-column">
            <div className="row">
              <div className="col-lg-12 px-0 px-lg-3">
                <div className="row new-navigation__list px-0">
                  <div className="col-lg-6 px-0 pb-lg-5 pt-lg-4">
                    {origin !== "language" && menuItems?.length > 0
                      ? menuItems?.map((item, i) => (
                          <NavigationSubItem
                            item={item}
                            link={item?.content?.slug}
                            externalLink={item?.content?.externalLink}
                            title={
                              !!item?.useCustomName && item?.name
                                ? item.name
                                : item?.content?.liferayFields?.title
                            }
                            target={item?.content?.target}
                            navigationMenuItems={item?.navigationMenuItems}
                            key={i}
                            origin={origin}
                            onHover={() => setHoverId(i)}
                          />
                        ))
                      : origin === "language" && item?.navigationMenuItems?.length > 0
                      ? item.navigationMenuItems?.map((item, i) => (
                          <NavigationSubItem
                            item={item}
                            title={
                              !!item?.useCustomName && item?.name
                                ? item.name
                                : item?.content?.liferayFields?.title
                            }
                            origin="language"
                            externalLink={`/${item?.content?.path}/`}
                            target="_blank"
                            key={i}
                          />
                        ))
                      : null}
                  </div>
                  {origin !== "language" && (
                    <div
                      className={classNames(
                        "col-12 col-lg-6 d-flex flex-column new-navigation__accessory pb-lg-5 pt-lg-4 pl-lg-5",
                        acBanner && acBanner?.content?.cta?.length > 0 && ""
                      )}
                    >
                      {acBanner && acBanner?.content?.cta?.length > 0 && (
                        <div
                          className={classNames(
                            "banner-menu__hide-wrapper w-100",
                            changeOrder && origin !== "support" && "order-2"
                          )}
                        >
                          <AccessoriesAndConsumablesBannerMenu
                            acBanner={acBanner}
                            className={classNames(
                              hoverId === -1 ||
                                !menuItems[hoverId]?.navigationMenuItems?.find(
                                  (item) => item?.content?.__typename === "LiferayAcBannerMenu"
                                )
                                ? ""
                                : "banner-menu--hide"
                            )}
                          />
                          {menuItems?.map((element, i) => (
                            <div key={i}>
                              <AccessoriesAndConsumablesBannerMenu
                                acBanner={element?.navigationMenuItems?.find(
                                  (item) => item?.content?.__typename === "LiferayAcBannerMenu"
                                )}
                                className={classNames(
                                  menuItems[hoverId] === element ? "" : "banner-menu--hide"
                                )}
                              />
                            </div>
                          ))}
                        </div>
                      )}
                      {acBanner && acBanner?.content?.cta?.length > 0 && (
                        <div
                          className={classNames(
                            "banner-menu__line",
                            changeOrder && origin !== "support" && "order-1"
                          )}
                        ></div>
                      )}
                      <div
                        className={classNames(
                          "row",
                          origin === "support" && "new-navigation__banner-wrapper--support"
                        )}
                      >
                        {origin === "support" && bannerMenu?.length > 0 ? (
                          bannerMenu.map((item, i) => (
                            <div key={i}>
                              <BannerMenu bannerMenu={item.content} origin="support" key={i} />
                              {bannerMenu?.length === 2 && i === 0 && (
                                <div className="new-navigation__bar-banner"></div>
                              )}
                            </div>
                          ))
                        ) : (
                          <div className="banner-menu__hide-wrapper w-100">
                            <div>
                              <BannerMenu
                                bannerMenu={categoryBanner?.content || defaultBanner}
                                origin={
                                  acBanner && acBanner?.content?.cta?.length > 0
                                    ? "accessories"
                                    : null
                                }
                                showVerticalBanner={showVerticalBanner}
                                className={classNames(
                                  hoverId === -1 ||
                                    !menuItems[hoverId]?.navigationMenuItems?.find(
                                      (item) =>
                                        item.content.__typename === "LiferayBannerMenu" &&
                                        item.navigationMenuItems?.length === 0
                                    )?.content
                                    ? ""
                                    : "banner-menu--hide"
                                )}
                              />
                            </div>
                            {menuItems?.map((element, i) => (
                              <div key={i}>
                                <BannerMenu
                                  bannerMenu={
                                    element?.navigationMenuItems?.find(
                                      (item) =>
                                        item.content.__typename === "LiferayBannerMenu" &&
                                        item.navigationMenuItems?.length === 0
                                    )?.content
                                  }
                                  origin={
                                    acBanner && acBanner?.content?.cta?.length > 0
                                      ? "accessories"
                                      : null
                                  }
                                  showVerticalBanner={showVerticalBanner}
                                  className={classNames(
                                    menuItems[hoverId] === element ? "" : "banner-menu--hide"
                                  )}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewNavigationMegamenu;
